import { IAddress } from '@commenda/types';
import { fetcher } from '@commenda/utils';

export type UpdateRegisteredAgentBody = {
  name?: string;
  address?: IAddress;
};

export async function updateRegisteredAgent(
  id: string,
  body: UpdateRegisteredAgentBody,
  token: string | undefined
) {
  const response = await fetcher(
    `registeredAgent/${id}`,
    {
      method: 'POST',
      body,
    },
    token
  );

  return response;
}
